export function consolidateInvestigationDeals(transactions: any[]): any[] {
  const consolidated: any[] = [];
  const deals = new Map<any, any>();

  transactions.forEach((transaction: any) => {
    const dealCode = transaction.deal_code;
    const found = deals.get(dealCode);
    if (found) {
      found.value += Number(transaction.value);
      found.risk_value += Number(transaction.risk_value);
      return;
    }

    const deal = { ...transaction };
    deals.set(dealCode, deal);
    consolidated.push(deal);
  });

  return consolidated;
}
